import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // disable: true,
    themes: {
      light: {
        primary: '#323e50',
        secondary: '#4bbbc1',
        anchor: '#8c9eff',
        accent: '#82B1FF',
        error: '#b71c1c',
        warning: '#795548',
        info: '#607d8b',
        success: '#ff5722',
        text: '#323e50',
        text_reversed: '#fff',
        gray: '#969da4',
        background: '#f4f8f9',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
